<section class="product-category-section" [formGroup]="categoryForm">
  <div class="field-container" [formGroup]="categoryFormControl">
    <div class="field-label">
      {{ 'text_addCategory' | dbText }}
    </div>
    <ds-dropdown [value]="categoryFormControl.get('id').valueChanges|async"
                 [selectOnEnter]="true"
                 (onFilterChange)="optionInputChange($event, categoryFormControl)"
                 [dsDropdownAddIfEmpty]="true"
                 [dsDropdownPlaceHolder]="'text_exClothing' | dbText"
                 [dsDropdownOptions]="dropdownCats"
                 (onFullOptionChoose)="onChooseCategory($event, categoryFormControl)"
                 [dsDropdownSearch]="true">
    </ds-dropdown>
  </div>
  <div class="field-container" [formGroup]="subcategoryFormControl">
    <div class="field-label">
      {{ 'text_subcategory' | dbText }}
    </div>
    <ds-dropdown [formControlName]="'id'"
                 [selectOnEnter]="true"
                 [value]="subcategoryFormControl.get('id').valueChanges|async"
                 (onFilterChange)="optionInputChange($event, subcategoryFormControl)"
                 [dsDropdownPlaceHolder]="'text_exJeans' | dbText"
                 [dsDropdownAddIfEmpty]="true"
                 [dsDropdownDisabled]="!(categoryFormControl.get('id').valueChanges|async)"
                 (onFullOptionChoose)="onChooseSubcategory($event, subcategoryFormControl)"
                 [dsDropdownOptions]="dropdownSubcats"
                 [dsDropdownSearch]="true">
    </ds-dropdown>
  </div>
  <div class="field-container">
    <div class="field-label">
      {{ 'text_collection' | dbText }}
    </div>
    <ds-dropdown [dsDropdownPlaceHolder]="collectionFormArray.controls?.length ? ('text_chooseLabel' | dbText) : ('text_exFallSale' | dbText)"
                 [selectOnEnter]="true"
                 [formControl]="collectionFormControl"
                 [dsDropdownOptions]="dropdownTags"
                 [dsDropdownAddIfEmpty]="true"
                 (onFullOptionChoose)="onChooseCollection($event)"
                 [dsDropdownSearch]="true">
    </ds-dropdown>
    <div [formArrayName]="'collection'" class="chip-grid" *ngIf="collectionFormArray.controls?.length">
      <div class="chip-row" *ngFor="let item of collectionFormArray.controls; let i = index">
        <span>{{item.get('name')?.value }}</span>
        <img src="./assets/images/icons/close-error-icon.svg"
             (click)="removeTag(i)">
      </div>
    </div>
  </div>
  <div class="field-container template">
    <div class="field-label">
      <div class="title">
        {{ 'text_productPageTemplate' | dbText }}
        <span>
        <i class="db-icon db-icon-ds-info-bg"
           [dsTooltip]="'text_addProductTemplateDesc'|dbText"
           dsTooltipPosition="right"
           dsTooltipColor="black"
           dsTooltipAlign="top">
        </i>
      </span>
      </div>
      <div class="edit-link">
        <a [href]="modifyRedirectionUrl(templateFormControl.get('id').valueChanges|async)" target="_blank">{{ 'text_edit' | dbText }}</a>
      </div>
    </div>
    <ds-dropdown [value]="templateFormControl.get('id').valueChanges|async"
                 [selectOnEnter]="true"
                 (onFilterChange)="optionInputChange($event, templateFormControl)"
                 [dsDropdownPlaceHolder]="'text_chooseTemplate' | dbText"
                 [dsDropdownOptions]="dropdownTemplates"
                 (onFullOptionChoose)="onChooseTemplate($event, templateFormControl)"
                 [dsDropdownSearch]="true">
    </ds-dropdown>
  </div>
</section>
